import { render } from "./VocabularyMeaningCard.vue?vue&type=template&id=27f72098&scoped=true"
import script from "./VocabularyMeaningCard.vue?vue&type=script&lang=js"
export * from "./VocabularyMeaningCard.vue?vue&type=script&lang=js"

import "./VocabularyMeaningCard.vue?vue&type=style&index=0&id=27f72098&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f72098"]])

export default __exports__